/** @format */

const readingListDustLogs = {
  // readingList 曝光
  readingListPageShowLog: {
    event: 'page_show',
    params: {
      page: 'readingList',
    },
  },
};

export default readingListDustLogs;
